import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '../api/api.service';
import { ApiResult } from '../models/api/api-result.model';

import { Test2Model } from '../models/Test/test2.model';
import { AiProductPackage } from '../models/Register/ai-product-pack.model';
import { ProjectItemModel } from '../models/dataman/ProjectItem.model';
import { ProjectDetailModel } from '../models/dataman/ProjectDetailModel.model';
import { PromptResult } from '../models/dataman/PromptResult.model';
import { DataCodeRequest } from '../models/dataman/DataCodeRequest.model';
import { DataCodePreviewModel } from '../models/dataman/DataCodePreviewModel.model';
import { DataCodeHistoryDeleteModel } from '../models/dataman/DataCodeHistoryDeleteModel.model';
import { EnmProjectType } from '../models/enums/EnmProjectType.enum';
import { MultiViewModel } from '../models/dataman/Reports/MultiViewModel.model';
import { ApplicationItemModel } from '../models/applications/ApplicationItem.model';
import { ApplicationItemDetailModel } from '../models/applications/ApplicationItemDetail.model';
import { CategoryModel } from '../models/categories/Category.model';
import { MarketBannerItem } from '../models/market-hero-slide/MarketBannerItem';
import { ProfileFavoriteModel } from '../models/applications/ProfileFavorite.model';



@Injectable({
  providedIn: 'root'
})
export class ApplicationService {



  constructor(private readonly apiService: ApiService) { }



  public GetAllApplications(): Observable<ApiResult<ApplicationItemModel[]>> {
    return this.apiService.get<ApplicationItemModel[]>('applications');
  }

  public GetApplication(slug:string,appPid: number): Observable<ApiResult<ApplicationItemDetailModel>> {
    return this.apiService.get<ApplicationItemDetailModel>(slug+'-a'+appPid);
  }


    public GetCategories(): Observable<ApiResult<CategoryModel[]>> {
    return this.apiService.get<CategoryModel[]>('/categories');
  }

  
  public GetBanners(): Observable<ApiResult<MarketBannerItem[]>> {
    return this.apiService.get<MarketBannerItem[]>('banners');
  }

      public GetFavorites(): Observable<ApiResult<ProfileFavoriteModel[]>> {
    return this.apiService.postnull<ProfileFavoriteModel[]>('/favorites');
  }

    public AddFavorite(pid:number): Observable<ApiResult<ProfileFavoriteModel[]>> {
    return this.apiService.postnull<ProfileFavoriteModel[]>('/favorite-add/'+pid);
  }
 
      public RemoveFavorite(pid:number): Observable<ApiResult<ProfileFavoriteModel[]>> {
    return this.apiService.postnull<ProfileFavoriteModel[]>('/favorite-remove/'+pid);
  }
 

}